var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutSpSa',[_c('LoginSpSa',{attrs:{"messages":{
      requiredUserName: 'Inserire il codice fiscale.',
      requiredPassword: 'Inserire la password.',
    },"richiestaResetInviata":_vm.richiestaResetInviata},on:{"login":_vm.login,"reset":_vm.reset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }